import { Alert, AlertTitle, Box, Chip, Typography } from '@mui/material';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import React from 'react';

interface PermissionMessageProps {
  requiredPermissions: string[];
  requirementType: 'single' | 'any' | 'all';
}

export const PermissionMessage: React.FC<PermissionMessageProps> = ({
  requiredPermissions,
  requirementType,
}) => {
  const getMessage = () => {
    if (requiredPermissions.length === 0) return 'Access denied';
    if (requiredPermissions.length === 1) return 'You need the following permission:';
    switch (requirementType) {
      case 'any':
        return 'You need at least one of these permissions:';
      case 'all':
        return 'You need all of these permissions:';
      default:
        return 'You need the following permission:';
    }
  };

  return (
    <Alert severity="info" icon={<LockOutlinedIcon />} data-testid="permission-message"
      sx={{ backgroundColor: 'background.paper', border: 1, borderColor: 'divider' }}>
      <AlertTitle>Permission Required</AlertTitle>
      <Typography variant="body2" sx={{ mb: 1 }}>{getMessage()}</Typography>
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
        {requiredPermissions.map(p => (
          <Chip key={p} data-testid="permission-chip" label={p} size="small" variant="outlined"
            sx={{ fontFamily: 'monospace', fontSize: '0.875rem' }} />
        ))}
      </Box>
    </Alert>
  );
};

